import React from 'react';
import Modal from '../Modal/Modal';
import RemoveConfirmation from './RemoveConfirmation';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import { Size } from '../../Enums/Size.enum';

interface RemoveConfirmationModalProps {
	opened: boolean;
	onClose: any;
	onConfirm?: () => void;
	confirmationText?: string;
	confirmationTitle?: string;
	confirmationNote?: string;
	customButtons?: () => React.ReactNode | React.ReactNode[];
	showAbort?: boolean;
}

export default function RemoveConfirmationModal(
	props: RemoveConfirmationModalProps,
) {
	const {
		opened,
		onClose,
		onConfirm,
		confirmationText,
		confirmationTitle = 'base.shared.remove',
		customButtons,
		showAbort,
		confirmationNote,
	} = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.MD}>
			<Modal.Header title={confirmationTitle} firstUpper />
			<Modal.Content>
				<RemoveConfirmation
					onConfirm={onConfirm}
					onAbort={onClose}
					confirmationText={confirmationText}
					customButtons={customButtons}
					showAbort={showAbort}
					confirmationNote={confirmationNote}
				/>
			</Modal.Content>
		</Modal>
	);
}
